class VideoPlayer {
  private readonly player: HTMLVideoElement;

  constructor(player: HTMLVideoElement) {
    this.player = player;
  }

  get _player() {
    return this.player;
  }

  onPlayVideo() {}

  onPauseVideo() {}

  onStopVideo() {}
}

export { VideoPlayer };
